import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import NavigationBarButton from '@/components/Navigation/NavigationBarButton';
import NavigationBarButtonContainer from '@/components/Navigation/NavigationBarButtonContainer';
import { useTranslation } from '@/hooks/useTranslation';
import useResponsiveness from '@/hooks/useResponsiveness';

export default function SidebarMobileActions({ onNewChat }) {
  const { t } = useTranslation();
  const { isXS } = useResponsiveness();
  if (Platform.OS !== 'ios' && Platform.OS !== 'android' && !(Platform.OS === 'web' && isXS)) return null;

  return (
    <View pointerEvents="box-none" style={styles.row}>
      <NavigationBarButtonContainer glass style={styles.glass}>
        <NavigationBarButton
          icon="pen-to-square"
          label={t('sidebar.newChat')}
          title={t('sidebar.newChat')}
          onPress={onNewChat}
          prependIconSize={21}
          textStyle={styles.label}
          style={styles.newChat}
        />
      </NavigationBarButtonContainer>
    </View>
  );
}

const styles = StyleSheet.create({
  row: { position: 'absolute', left: 0, right: 0, bottom: 8, paddingHorizontal: 16,
    flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' },
  glass: { borderRadius: 28 },
  newChat: { height: 46, minHeight: 46, paddingHorizontal: 18, paddingVertical: 0, borderRadius: 24 },
  label: {
    fontSize: 17,
    lineHeight: 20,
    fontWeight: '600',
    includeFontPadding: false,
    textAlignVertical: 'center',
    // Optically center the letters with the adjacent square compose icon.
    transform: [{ translateY: -1 }],
  },
});
